<template lang="pug">
    .app-container
        Sidebar
        .app-wrapper
            transition(name="fade" mode="out-in")
                LoadIndicator(:list="loadList" v-if="loadList.length")
            .container.is-fluid
                .section
                    h3.title {{ $route.name }}
                    transition(name="fade" mode="out-in")
                        router-view(:key="$route.name")
        transition(name="fade" mode="out-in")
            LiveFilter(v-if="['Live', 'DadBee', 'Profiles'].includes($route.name)" @saveSettings="saveFilterSettings" @save="saveFilters")
        v-dialog
</template>

<script>
import LoadIndicator from "./LoadIndicator";
import LiveFilter from "./LiveFilter";
import Sidebar from "./Sidebar";

export default {
  name: "Layout",
  components: {
    Sidebar,
    LiveFilter,
    LoadIndicator
  },
  computed: {
    loadList() {
      return this.$store.state.loadList;
    }
  },
  methods: {
    saveFilters({ category, filters }) {
      this.$store
        .dispatch("setFilters", { category, filters })
        .catch(console.log);
    },
    saveFilterSettings({ category, settings }) {
      this.$store
        .dispatch("setFilterSettings", { category, settings })
        .catch(console.log);
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;

  @media screen and (max-width: $tablet) {
    flex-direction: column;
  }

  .app-wrapper {
    order: 3;
    position: relative;
    flex: 1;
    overflow-y: auto;
  }
}
</style>

<style lang="scss">
.app-container {
  ::selection {
    color: $defaultColor;
    background: $brandColor;
  }

  .title,
  .subtitle {
    color: $defaultColor;

    .icon {
      margin-right: 0.5rem;
    }
  }

  .notification {
    background-color: #313c44;
  }

  .text-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .button {
    transition: all 0.2s ease-in-out;

    &.is-primary {
      background-color: $brandColor !important;
      &:hover {
        background-color: lighten($brandColor, 10%) !important;
      }
    }
    &.is-danger {
      background-color: $errorColor !important;
      &:hover {
        background-color: lighten($errorColor, 10%) !important;
      }
    }
    &.is-warning {
      background-color: $warnColor !important;
      &:hover {
        background-color: lighten($warnColor, 10%) !important;
      }
    }
    &.is-info {
      background-color: $infoColor !important;
      &:hover {
        background-color: lighten($infoColor, 10%) !important;
      }
    }
    &.is-success {
      background-color: $successColor !important;
      &:hover {
        background-color: lighten($successColor, 10%) !important;
      }
    }
  }

  .has-text-danger {
    color: $errorColor !important;
  }
  .has-text-warning {
    color: $warnColor !important;
  }
  .has-text-info {
    color: $infoColor !important;
  }
  .has-text-success {
    color: $successColor !important;
  }

  .is-link {
    color: $sublinkColor;
    text-decoration: underline;
    transition: all 0.3s;

    &:hover {
      opacity: 0.8;
    }
  }

  .v--modal-overlay {
    .v--modal {
      color: #333;

      .vue-dialog-button {
        &:not(:empty):hover {
          background-color: rgba(0, 0, 0, 0.08);
        }
        &:empty {
          cursor: default;
        }
      }
    }
  }

  .page {
    position: relative;

    .title-link {
      position: absolute;
      top: -3rem;
      right: 0;
    }
  }

  .search-control {
    .input {
      background-color: transparent;
      border: none;
      border-bottom: 1px solid darken($defaultColor, 30%);
      border-radius: 0;
      box-shadow: none;

      &::placeholder {
        transition: all 0.2s linear;
        color: darken($defaultColor, 30%);
      }

      &:focus {
        color: $defaultColor;
        border-color: $defaultColor;

        & + .icon {
          color: $defaultColor;
        }

        &::placeholder {
          color: $defaultColor;
        }
      }
    }
    .input,
    .icon {
      color: darken($defaultColor, 30%);
      transition: all 0.2s linear;
    }
  }
}
</style>
